import { Link } from "react-router-dom";
import Seo from "../lib/Seo";

export default function NotFound() {
    return (
        <>
            <Seo
                title="Página no encontrada"
                description="La página que buscas no existe."
                path="/404"
                noindex
            />
            <section className="flex min-h-[60vh] items-center justify-center px-4 py-20">
                <div className="max-w-md text-center">
                    <p className="text-xs uppercase tracking-widest text-cyan-400">
                        Error 404
                    </p>
                    <h1 className="mt-3 text-4xl font-bold text-slate-50 sm:text-5xl">
                        Página no encontrada
                    </h1>
                    <p className="mt-4 text-slate-400">
                        La dirección que buscas fue movida o no existe. Vuelve al
                        inicio o explora el directorio de centros.
                    </p>
                    <div className="mt-8 flex justify-center gap-3">
                        <Link
                            to="/"
                            className="rounded-md bg-cyan-500 px-5 py-2.5 text-sm font-semibold text-slate-950 hover:bg-cyan-400"
                        >
                            Inicio
                        </Link>
                        <Link
                            to="/centros"
                            className="rounded-md border border-slate-700 px-5 py-2.5 text-sm font-semibold text-slate-100 hover:bg-slate-800"
                        >
                            Ver centros
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}
